<template>
  <div>
    <v-toolbar text class="transparent">
      <v-list class="pa-0">
        <v-list-item>
            <v-list-item-avatar v-if="miniVariant">
              <v-btn text  transparent icon>
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-list-item-avatar>

            <v-list-item-content>
              <img  width="150px" src="/img/logo.jpg">
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                icon
                @click.stop="miniVariant = !miniVariant"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
      </v-list>
    </v-toolbar>
    <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            v-model="item.model"
            :key="item.title"
            :to="!item.route? '' : item.route"
            :prepend-icon="item.icon"
            :append-icon="item.model ? 'mdi-chevron-up': item['icon-alt']"
            no-action

          >
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.route == '#' ? '' : child.route"
              class="$router.path==child.route? 'red--text' : ''"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else
            :key="item.title"
            :to="item.route == '#' ? '' : item.route"
            class=""
            active-class="">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean
    },
    miniVariant: {
      type: Boolean
    }
  },
  data () {
    return {
      name: this.$t('nav_menu_title'),
      items: [
        { icon: 'mdi-chart-bar', title: 'Accueil' },
        {
          icon: 'mdi-account-group-outline',
          'icon-alt': 'mdi-chevron-down',
          title: 'Acteurs',
          model: false,
          children: [
            {
              title: 'Créer un acteur',
              route: { name: 'actors.new' }
            },
            {
              title: 'Liste des acteurs',
              route: { name: 'actors.list' }
            },
            {
              title: 'Liste des acteurs non validés',
              route: { name: 'actors.list_validate' }
            }
          ]
        },
        {
          icon: 'mdi-calendar-month-outline',
          'icon-alt': 'mdi-chevron-down',
          title: 'Evènements',
          model: false,
          children: [
            {
              title: 'Créer un évènement',
              route: { name: 'events.new', params: { eventId: 'new' }}
            },
            {
              title: 'Evènements à réaliser',
              route: { name: 'events.coming' }
            },
            {
              title: 'Evènements en cours',
              route: { name: 'events.in_progress' }
            },
            {
              title: 'Evènements réalisés',
              route: { name: 'events.past' }
            },
            {
              title: 'Evènements non validés',
              route: { name: 'events.validate' }
            }
          ]
        },
        {
          icon: 'mdi-account-card-details-outline',
          'icon-alt': 'mdi-chevron-down',
          title: 'Cartes',
          model: false,
          children: [
            {
              title: 'Créer une carte',
              route: { name: 'cards.new' }
            },
            {
              title: 'Liste des cartes',
              route: { name: 'cards.list' }
            }
          ]
        },
        {
          icon: 'mdi-account-circle-outline',
          'icon-alt': 'mdi-chevron-down',
          title: 'Utilisateurs',
          route: '#'
        },
        {
          icon: 'mdi-settings-outline',
          title: 'Paramètres',
          route: { name: 'settings.profile' }
        },
        {
          icon: 'mdi-help-rhombus-outline',
          title: 'Aide',
          route: '#'
        },
        {
          icon: 'mdi-information-outline',
          title: 'A propos',
          route: '#'
        }
      ]
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenu.vue